import Ajaxinate from '../utils/ajaxnate';
import { mediaQuery } from '../utils/mediaQuery';
import { $Q, $Qll } from '../utils/querySelector';

class Archive {
  constructor() {
    this.inputSearch = document.querySelector('input[id="Search-In-Template"]');
    this.archivePage = $Q('.isArchive') && $Q('.isArchive');
    this.archiveBlog =
      $Q('.blog-archive.isArchive') && $Q('.blog-archive.isArchive');

    if (this.archivePage) {
      this.infiniteScroll();
      mediaQuery('(max-width: 991px)', this.photographerFiltersContainer);
      this.cleanFiltersSelected();
    }

    this.modalHeaderSearch = $Q('#header-modal-search');
    this.buttonOpenSearch = $Q('#js-open-search');
    this.buttonCloseSearch = $Q('#js-close-search');
    this.isOpen = false;

    this.modalInit();
    this.currentFilter();
    this.mainBlogFilter();
    this.removeTagForSize($Qll('.article-card'));
    this.observeInsertNodes();

    mediaQuery(
      '(min-width: 991px)',
      this.adjustContainerBlogFilters.bind(this)
    );
  }

  /**
   * Add margin bottom to the container tags and container search to aline elements
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  adjustContainerBlogFilters() {
    if (this.getScroll($Q('.blog-archive__filters'))) {
      $Q('#js-photographers-tags').style.paddingBottom = '10px';
      $Q('.blog-archive__search').style.paddingBottom = '10px';
    }
  }

  /**
   * return true if element has scroll or false if not has scroll
   * @param {Node} el - Node to calculate if has scroll or not
   * @returns {Boolean}
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  getScroll(el) {
    return el?.scrollWidth > el?.clientWidth;
  }

  infiniteScroll() {
    if (document.querySelector('#js-infinite-scroll-archive')) {
      new Ajaxinate({
        container: '#js-infinite-scroll-archive',
        pagination: '#js-infinite-scroll-paginate',
        loadingText: `${this.loaderComponent()}`,
        offset: 3000,
      });
    }
  }

  /**
   * Loader component as a string, to render with JS
   * @returns {NodeString} HTML as a string
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  loaderComponent = () => `
    <div class="loading-overlay collections">
      <div class="loading-overlay__spinner">
        <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="28"></circle>
        </svg>
      </div>
    </div>
  `;

  /**
   * Get all tags elements and calculate width and margin
   * Add width and margin
   * Add 50px margin error
   * Insert result as a width of container tags for mobile
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  photographerFiltersContainer() {
    const tags = $Qll('a', $Q('#js-photographers-tags'));
    let sumElements = 0;

    for (let index = 0; index < tags.length; index++) {
      sumElements =
        sumElements +
        tags[index].offsetWidth +
        parseInt(
          window.getComputedStyle(tags[index]).marginRight.split('px')[0]
        );
    }

    $Q('#js-photographers-tags').style.width = `${sumElements + 50}px`;
  }

  /**
   *  Get what tag is current and add or remove class
   * Validate if are in photographers
   */
  cleanFiltersSelected() {
    const filterShowAll = $Q('.filter-show-all');

    if (window.location.pathname === '/blogs/photographers/') {
      if (filterShowAll && !filterShowAll.classList.contains('isTagCurrent')) {
        filterShowAll.classList.add('isTagCurrent');
      }
    } else {
      if (filterShowAll && filterShowAll.classList.contains('isTagCurrent')) {
        filterShowAll.classList.add('isTagCurrent');
      }
    }
  }

  /**
   * Init Modal
   */
  modalInit() {
    this.closeModalSearch(this.buttonCloseSearch);
    this.openModalSearch(this.buttonOpenSearch);
  }

  /**
   * Open Modal
   */
  openModalSearch(el) {
    if (el) {
      el.addEventListener('click', () => {
        if (!this.isOpen) {
          setTimeout(() => {
            this.inputSearch.focus();
          }, 500);
          this.modalHeaderSearch.classList.add('isActive');
          this.isOpen = true;
          const inputSearch = $Q('#Search-In-Template');
          setTimeout(() => {
            inputSearch.focus();
          }, 1000);
        }
      });
    }
  }

  /**
   * Close Modal
   */
  closeModalSearch(el) {
    if (el) {
      el.addEventListener('click', () => {
        if (this.isOpen) {
          this.modalHeaderSearch.classList.remove('isActive');
          this.isOpen = false;
        }
      });
    }
  }

  /**
   * Add event change to input select and redirect to the tag chose
   */
  mainBlogFilter() {
    const selectFilter = document.querySelector('.blog-filters-mobile__select');

    if (selectFilter) {
      selectFilter.addEventListener(
        'change',
        (e) => {
          window.location = e.target.value;
        },
        false
      );
    }
  }

  /**
   * Search is any tag has de current css class to add or remove to the show all button
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  currentFilter() {
    const filterShowAll = $Q('.blog-filters__tags a.isShowAll');
    const tagCurrent = $Qll('.blog-filters__tags a:not(.isShowAll)').filter(
      (tag) => {
        return tag.classList.contains('isTagCurrent');
      }
    );

    if (tagCurrent[0]) {
      filterShowAll && filterShowAll.classList.remove('isTagCurrent');
    } else {
      filterShowAll && filterShowAll.classList.add('isTagCurrent');
    }
  }

  /**
   * Remove tag if the tags container is overflow of the article card
   * Start to last tag
   * It is recursive, if the tags container is still overflow delete the next tag
   * Loop of article cards
   * @param {Node} cards
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  removeTagForSize(cards) {
    const blogCard = cards || $Qll('.article-card');

    blogCard &&
      blogCard.forEach((card) => {
        const tagListContainer = $Q('.article-card__tags', card);

        if (tagListContainer) {
          if (tagListContainer.clientWidth + 15 > card.clientWidth) {
            const tags = $Qll('li', tagListContainer);

            if (tags && tags.length) {
              tags[tags.length - 1].remove();
            }

            this.removeTagForSize(cards);
          } else {
            return;
          }
        }
      });
  }

  /**
   * Callback of mutations observer
   * Observe nodes inserted in blog archive grid for Ajaxnite
   * Filter article cards inserted
   * Call removeTagForSize method with the article cards filtered
   * @param {Object} mutations - Mutations
   * @see observeInsertNodes
   * @see removeTagForSize
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  _cbObserveInsertNodes(mutations) {
    mutations.forEach((mutation) => {
      const cards = [...mutation.addedNodes].filter((el) => {
        if (el.classList && el?.classList.contains('article-card')) {
          return el;
        }
      });

      if (mutation.type === 'childList') {
        this.removeTagForSize(cards);
      }
    });
  }

  /**
   * Listener insert article card to run removeTagForSize
   * @see cbObserveInsertNodes
   * @see removeTagForSize
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  observeInsertNodes() {
    const config = {
      childList: true,
    };

    const observer = new MutationObserver(
      this._cbObserveInsertNodes.bind(this)
    );

    if ($Q('#js-infinite-scroll-archive')) {
      observer.observe($Q('#js-infinite-scroll-archive'), config);
    }
  }
}

export { Archive };
